import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { EType } from '@blade/common/interfaces/user-group';
import { handleError } from '@blade/common/utils/handle-error';
import { mapTags } from '@blade-sxp/pass/utils/map-tree';
import TreePopover from '@blade-sxp/pass/components/tree-popover.vue';
import { validateOnlyAlphanumeric } from '@blade/common/utils/validate';
let default_1 = class extends Vue {
    title = '';
    form = { user_name: '', access: '' };
    tags = [];
    id = '';
    get visitorgroup() {
        return {
            user_name: {
                required: true,
                trigger: ['blur', 'change'],
                validator: (rule, value, callback) => {
                    if (!value) {
                        callback(new Error(this.$t('groupError').toString()));
                    }
                    else if (!validateOnlyAlphanumeric(value)) {
                        callback(new Error(this.$t('groupNameError').toString()));
                    }
                    else {
                        callback();
                    }
                },
            },
        };
    }
    handleClick(e) {
        const res = e.filter((item) => item.type && Number(item.type) === 1);
        this.tags = res;
    }
    handleClose(e) {
        const res = this.tags.filter((item) => item.id !== e.id);
        this.tags = res;
    }
    handleDelete() {
        this.tags = [];
    }
    mounted() {
        const { meta, params } = this.$route;
        console.log('router:', meta);
        this.title = meta.page;
        this.id = params.id;
        if (this.title === 'editVisitorGroup') {
            this.getUser();
        }
    }
    handleSubmit() {
        this.$refs['group-form'].validate((valid) => {
            if (valid) {
                if (this.title === 'createVisitorGroup') {
                    this.createStaff();
                }
                else {
                    this.updateStaff();
                }
            }
            else {
                console.log('error submit!!');
                return false;
            }
        });
    }
    async createStaff() {
        const res = this.tags.length > 0 ? this.tags.map((item) => item.id) : [];
        try {
            await StaffModule.createStaff({
                maxSize: 0,
                name: this.form.user_name,
                remark: '',
                personGroup: EType.GUEST,
                userIds: res,
            });
            this.$elmessage.success(this.$t('visitorGroup').toString());
            this.$router.push({ path: '/traffic/staff/visitor', query: { group: 'GROUP' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    async updateStaff() {
        const res = this.tags.length > 0 ? this.tags.map((item) => item.id) : [];
        try {
            await StaffModule.updateStaff({
                id: this.id,
                name: this.form.user_name,
                remark: '',
                userIds: res,
            });
            this.$elmessage.success(this.$t('editSuccess').toString());
            this.$router.push({ path: '/traffic/staff/visitor', query: { group: 'GROUP' } });
        }
        catch (e) {
            handleError(e);
        }
    }
    async getUser() {
        try {
            const res = await StaffModule.getStaffById(this.id);
            this.form.user_name = res.data.name;
            this.tags = mapTags(res.data);
        }
        catch (e) {
            handleError(e);
        }
    }
    handleCancel() {
        this.$router.push({ path: '/traffic/staff/visitor', query: { group: 'GROUP' } });
    }
};
default_1 = __decorate([
    Component({
        name: 'CreatePortrait',
        components: { TreePopover },
        i18n: {
            messages: {
                'en-us': {
                    upload: 'Please upload the portrait',
                    createVisitorGroup: 'Create VisitorGroup',
                    groupName: 'VisitorGroup Name',
                    groupAccess: 'VisitorGroup Access',
                    access: 'Please input name/organization',
                    submit: 'Submit',
                    cancel: 'Cancel',
                    editVisitorGroup: 'Edit VisitorGroup',
                    groupNameError: 'Only alphanumeric allowed',
                    groupError: 'Please input group',
                    visitorGroup: 'Successfully created visitor Group',
                    editSuccess: 'Successfully edited',
                },
                zh: {
                    upload: '请上传人像',
                    createVisitorGroup: '创建访客组',
                    groupName: '人员组名称',
                    groupAccess: '人员组权限',
                    access: '请输入姓名/部门',
                    submit: '确认',
                    cancel: '取消',
                    editVisitorGroup: '编辑访客组',
                    groupNameError: '不能输入英文数字之外的字符',
                    groupError: '请输入人员组名称',
                    visitorGroup: '成功创建访客',
                    editSuccess: '修改成功',
                },
            },
        },
    })
], default_1);
export default default_1;
